import type {CreateUserFormPayload} from "./create-user.schema";
import type {CreateUserRequest} from "@project/sdk/admin";

export const createUserMapper = {
  toSdk: (payload: CreateUserFormPayload): CreateUserRequest => ({
    name: payload.name,
    email: payload.email,
    role: payload.role,
    bio: payload.bio ?? null,
    seniority: payload.seniority,
    department: payload.department,
  }),
};
